// AboutIntro.js
import React from 'react';
import { motion } from 'framer-motion';

const AboutIntro = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <p className="text-lg md:text-xl text-gray-700 font-light leading-relaxed mb-6">
              Notapaths is a global mobility support company focused on helping individuals make informed decisions about studying and working abroad. Through personalised consultations, trusted partnerships, and structured processes, we guide candidates through complex international pathways with transparency and care.
            </p>
            <p className="text-lg md:text-xl text-gray-700 font-normal leading-relaxed">
              Our work is grounded in preparation, honest assessment, and long term outcomes.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
